module.exports = __webpack_public_path__ + "img/tiendamia-logo.f11ff3df.png";